import api from "../config/api";

// Node listesi
export const getNodes = async () => {
  try {
    const response = await api.get("/node");
    console.log("API Response:", response);
    return response;
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

// Tek bir node getirme
export const getNodeById = async (id) => {
  try {
    const response = await api.get(`/node/${id}`);
    console.log("API Response:", response);
    return response;
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

// Node durumu güncelleme
export const updateNodeStatus = async ({ id, status }) => {
  try {
    const response = await api.patch(`/node/${id}/status`, { status });
    console.log("API Response:", response);
    return response;
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

// Node silme
export const deleteNode = async (id) => {
  try {
    const response = await api.delete(`/node/${id}`);
    console.log("API Response:", response);
    return response;
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

// Node sağlık kontrolü
export const checkNodeHealth = async (attributes) => {
  try {
    const response = await api.get("/node/health/check", {
      params: { attributes },
    });
    console.log("API Response:", response);
    return response;
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};
